import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-pending-pick-up-list",
    template: `
        <section-warehouse-order-list [state]="state" [pending_pickup]="true"
                                      header="Orders pending for pickup"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderPendingPickupListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-pending-pick-up",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
